import { render, staticRenderFns } from "./IconRight.vue?vue&type=template&id=f4046aea&"
import script from "./IconRight.vue?vue&type=script&lang=js&"
export * from "./IconRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports